import { Organization } from '@esub-engineering/platform-types';

export const SET_ORG_INFO = 'SET_ORG_INFO';

export const setOrganizationInfo = (payload: Partial<Organization>) => ({
  type: SET_ORG_INFO,
  payload,
});
